import { Navigate } from "react-router-dom";
import Icon from "@mui/material/Icon";
import Titles from "layouts/titles";
import ShowTile from "layouts/titles/showTile/index";
import ShowThreeD from "layouts/titles/ShowThreeD.js";
import PresentationTitles from "prof/presentationTitles";
import PresentationMakerPage from "prof/presentationTitles/PresentationMakerPage";
import UsmlePrepAdminPage from "layouts/usmlePrep";

/**
 * Routes available to custom_user — filtered by web_permissions in App.js.
 */
const customUserRoutes = [
  {
    route: "/dashboard",
    key: "dashboardRedirect",
    component: <Navigate to="/titles" replace />,
  },
  {
    type: "collapse",
    name: "3D Models",
    key: "threeDTitles",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/threeDTitles",
    component: <Titles type="three_d_model" />,
    webModule: "three_d_models",
  },
  {
    type: "collapse",
    name: "Embryology 3D models",
    key: "embryologyThreeDTitles",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/embryologyThreeDTitles",
    component: <Titles type="emb_3d_model" />,
    webModule: "embryology_3d",
  },
  {
    type: "collapse",
    name: "Anatomy",
    key: "anatomyTitles",
    icon: <Icon fontSize="small">accessibility_new</Icon>,
    route: "/anatomyTitles",
    component: <Titles type="anatomy" />,
    webModule: "anatomy",
  },
  {
    type: "collapse",
    name: "USMLE Prep",
    key: "usmle-prep",
    icon: <Icon fontSize="small">medical_services</Icon>,
    route: "/usmle-prep",
    component: <UsmlePrepAdminPage />,
    webModule: "usmle",
  },
  {
    type: "collapse",
    name: "Histology",
    key: "titles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/titles",
    component: <Titles type="his" />,
    webModule: "histology",
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" />,
    webModule: "embryology",
  },
  {
    type: "collapse",
    name: "Radiology",
    key: "radiologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/radiologyTitles",
    component: <Titles type="rad" />,
    webModule: "radiology",
  },
  {
    type: "collapse",
    name: "Presentations",
    key: "presentationTitles",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/presentationTitles",
    component: <PresentationTitles type="presentation" />,
    webModule: "presentations",
  },
  {
    name: "presentationMakerPage",
    key: "presentationMakerPage",
    route: "/presentationMakerPage/:id/:lang",
    component: <PresentationMakerPage />,
    webModule: "presentations",
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
];

export default customUserRoutes;
